export default {
  loading: (typeof window !== 'undefined'),
  // loading: false,
  loginClass: 'with-panel with-panel-left build',
  unloginedClass: 'with-panel web',
  exact: true
};
